import * as React from 'react'
import { BaseEdge, getBezierPath, type EdgeProps } from '@xyflow/react'

import { BOARD } from 'components_new/molecules/Node/accents'

/**
 * "Marching dots" edge: a calm, on-brand connection rendered as slowly moving
 * round green dots. Signals live data flow without the fatigue of
 * a fully animated line. The keyframe `hpDash` and the prefers-reduced-motion
 * override live in the board stylesheet (DrawingBoard/style.css).
 */
const Edge: React.FC<EdgeProps> = (props) => {
  const {
    id,
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
    selected,
    markerStart,
    markerEnd,
    style: styleProp
  } = props

  const stroke = selected ? BOARD.signalGreenDark : BOARD.signalGreen

  const [edgePath] = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition
  })

  const style: React.CSSProperties = {
    stroke,
    strokeWidth: 2.25,
    strokeDasharray: '1 7',
    strokeLinecap: 'round',
    animation: 'hpDash 1s linear infinite',
    ...styleProp
  }

  return (
    <BaseEdge
      id={id}
      path={edgePath}
      className="react-flow__edge-path"
      style={style}
      markerStart={typeof markerStart === 'string' ? markerStart : undefined}
      markerEnd={typeof markerEnd === 'string' ? markerEnd : undefined}
    />
  )
}

export default Edge
